<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="['accept-terms', getSelectedDEV && 'dev-selected-component']">
    <div id="scroll-target" :style="'max-height:' + schema.textVisibleHeight + 'px'" class="overflow-y-auto">
      <div v-scroll:#scroll-target="onScroll" v-html="value || loremIpsum"></div>
    </div>
  </div>
</template>

<script>
import eventBus from 'vue-option-events';
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  mixins: [abstractField, devComponentMixin],

  data: () => ({
    position: 0,
    textHeight: 0
  }),

  mounted() {
    let text = document.querySelectorAll('.accept-terms #scroll-target > div');

    if (text.length) {
      this.textHeight = text[0].offsetHeight - this.schema.textVisibleHeight;
    }
  },

  methods: {
    onScroll: function(e, position) {
      this.position = e.target.scrollTop;
    }
  },

  watch: {
    position(newValue) {
      if (this.textHeight === newValue) {
        eventBus.$emit(HANDLERS.ENABLED_FIELD, this.schema.enabledfield);
      }
    }
  }
};
</script>
